import { createReducer, on } from '@ngrx/store';
import { setTotalValuesCoverageAction } from './totalsValueCoverage.actions';

export const initialState = {};

export const totalsValueCoverageReducer = createReducer(
  initialState,
  on(setTotalValuesCoverageAction, (state, { TotalValues }) => TotalValues)
);